import notificationReducer, { notificationPersistConfig } from './reducer';

export * from './types';
export * from './actions';

export { notificationPersistConfig };

export default notificationReducer;
